import {
  VetaCenterReadinessItemKind,
  VetaCenterReadinessRecordType,
} from '@treadinc/horizon-api-spec';
import { t } from 'i18next';

import isEnumValue from '~utils/isEnumValue';

import { VetaCenterReadinessItem } from './models';

const KEY_PREFIX = 'administration.integration.veta_center.readiness';

const gapLabelKeys = {
  [VetaCenterReadinessItemKind.DOT_NUMBER_MISSING]: `${KEY_PREFIX}.gaps.dot_number_missing`,
  [VetaCenterReadinessItemKind.DRIVER_CLASSIFICATION_MISSING]: `${KEY_PREFIX}.gaps.driver_classification_missing`,
  [VetaCenterReadinessItemKind.EXTERNAL_ID_MISSING]: `${KEY_PREFIX}.gaps.external_id_missing`,
  [VetaCenterReadinessItemKind.LICENSE_NUMBER_MISSING]: `${KEY_PREFIX}.gaps.license_number_missing`,
  [VetaCenterReadinessItemKind.MATERIAL_CODE_MISSING]: `${KEY_PREFIX}.gaps.material_code_missing`,
  [VetaCenterReadinessItemKind.MAX_GROSS_WEIGHT_MISSING]: `${KEY_PREFIX}.gaps.max_gross_weight_missing`,
  [VetaCenterReadinessItemKind.NOT_REGISTERED]: `${KEY_PREFIX}.gaps.not_registered`,
  [VetaCenterReadinessItemKind.OVERWEIGHT_PERMIT_NUMBER_MISSING]: `${KEY_PREFIX}.gaps.overweight_permit_number_missing`,
  [VetaCenterReadinessItemKind.OWN_FLEET_HAULER_COMPANY_MISSING]: `${KEY_PREFIX}.gaps.own_fleet_hauler_company_missing`,
  [VetaCenterReadinessItemKind.SITE_ADDRESS_MISSING]: `${KEY_PREFIX}.gaps.site_address_missing`,
  [VetaCenterReadinessItemKind.SITE_STATE_UNSUPPORTED]: `${KEY_PREFIX}.gaps.site_state_unsupported`,
  [VetaCenterReadinessItemKind.SOURCE_OPERATOR_DEFAULT_MISSING]: `${KEY_PREFIX}.gaps.source_operator_default_missing`,
  [VetaCenterReadinessItemKind.VENDOR_ACCOUNT_MISSING]: `${KEY_PREFIX}.gaps.vendor_account_missing`,
  [VetaCenterReadinessItemKind.VENDOR_DOT_NUMBER_MISSING]: `${KEY_PREFIX}.gaps.vendor_dot_number_missing`,
} satisfies Record<VetaCenterReadinessItemKind, string>;

// A kind newer than the pinned spec falls back to a neutral label.
export function getGapLabel(kind: VetaCenterReadinessItemKind) {
  return t(
    isEnumValue(VetaCenterReadinessItemKind, kind)
      ? gapLabelKeys[kind]
      : `${KEY_PREFIX}.gaps.unknown`,
  );
}

export interface ReadinessRecord {
  id: string;
  items: VetaCenterReadinessItem[];
  name: string;
  type: VetaCenterReadinessRecordType;
}

// Records of a type newer than the pinned spec are left out so they are not counted unseen.
export function groupReadinessRecords(items: VetaCenterReadinessItem[]) {
  const records = new Map<string, ReadinessRecord>();
  items
    .filter((item) => isEnumValue(VetaCenterReadinessRecordType, item.recordType))
    .forEach((item) => {
      const key = `${item.recordType}/${item.recordId}`;
      const record = records.get(key) ?? {
        id: item.recordId,
        items: [],
        name: item.recordName,
        type: item.recordType,
      };
      record.items.push(item);
      records.set(key, record);
    });

  return [...records.values()];
}
